/** Liste API: `""` = tüm kayıtlar, `undefined` = varsayılan aktif. */
export function resolveActiveQueryParam(
  value: boolean | "" | undefined,
): string | undefined {
  if (value === "") return undefined;
  if (value === false) return "false";
  return "true";
}

export function resolveStudentStatusQueryParam(
  value: "active" | "passive" | "graduated" | "" | undefined,
): string | undefined {
  if (value === "") return undefined;
  if (value === undefined || value === "active") return "active";
  return value;
}

export function resolveUserActiveQueryParam(
  value: "" | "true" | "false" | undefined,
): string | undefined {
  if (value === "") return undefined;
  if (value === "false") return "false";
  return "true";
}
